import { LEAD_SOURCE_NONE } from "../../../Leads/constants/lead-source-none.ts"
import type { ProjectFormData } from "../components/project-form-data.ts"
import type {
  ProjectWizardCustomer,
  ProjectWizardFormData
} from "./project-wizard-data.ts"

const WIZARD_CUSTOMER_FIELDS = [
  "first_name",
  "last_name",
  "phone",
  "email"
] as const

function trimmed(value: unknown): string {
  return typeof value === "string" ? value.trim() : ""
}

function customerFields(
  customer: ProjectWizardCustomer | null | undefined
): ProjectFormData["customer"] {
  const result: NonNullable<ProjectFormData["customer"]> = {}

  for (const field of WIZARD_CUSTOMER_FIELDS) {
    const value = trimmed(customer?.[field])
    if (value) result[field] = value
  }

  return Object.keys(result).length ? result : undefined
}

/**
 * Builds the single POST the wizard makes — only the fields the two steps
 * actually collect. `lead_name` and `project_type` are the only two the UI
 * requires; everything else (address, scope, financials, team) is left for
 * the Project View/Edit experience, exactly as the current full form leaves
 * them optional at the API layer.
 */
function buildCreateProjectWizardPayload(
  values: ProjectWizardFormData
): ProjectFormData {
  const payload: ProjectFormData = {
    lead_name: trimmed(values.lead_name),
    source: trimmed(values.source) || LEAD_SOURCE_NONE
  }

  const projectTypes = (values.project_type ?? []).filter(Boolean)
  if (projectTypes.length) payload.project_type = projectTypes

  if (trimmed(values.start_date))
    payload.start_date = trimmed(values.start_date)
  if (trimmed(values.end_date)) payload.end_date = trimmed(values.end_date)
  if (trimmed(values.project_creation_date)) {
    payload.project_creation_date = trimmed(values.project_creation_date)
  }
  if (trimmed(values.comments)) payload.comments = trimmed(values.comments)

  const customer = customerFields(values.customer)
  if (customer) payload.customer = customer

  return payload
}

export { buildCreateProjectWizardPayload }
